import React from 'react'

const LeadsNotContactedIcon: React.FC = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
   >
      <path
         d="M12.7715 26.8346C12.7715 27.571 13.3684 28.168 14.1048 28.168H19.4382C20.1745 28.168 20.7715 27.571 20.7715 26.8346V20.168L27.4382 20.168C28.1745 20.168 28.7715 19.571 28.7715 18.8346V13.5013C28.7715 12.7649 28.1745 12.168 27.4382 12.168H20.7715L20.7715 5.5013C20.7715 4.76492 20.1745 4.16797 19.4382 4.16797H14.1048C13.3684 4.16797 12.7715 4.76492 12.7715 5.5013V12.168H6.10482C5.36844 12.168 4.77148 12.7649 4.77148 13.5013V18.8346C4.77148 19.571 5.36844 20.168 6.10482 20.168H12.7715V26.8346Z"
         stroke="white"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
)

export default LeadsNotContactedIcon
